import Holidays from 'date-holidays'
import { HolidayType } from '../types/holidays'
import { bareSubdivisionCode } from '../data/countries'

export interface IDateHolidaysHoliday {
  date: string
  start: Date
  end: Date
  name: string
  rule: string
  type: string
  note?: string
}

interface Options {
  timezone?: string
  languages?: string[]
  types?: HolidayType[]
}

export class PublicHolidaysRepository {
  private holidays: Holidays
  private options: Options

  constructor(locale?: string, timezone?: string) {
    this.options = {
      timezone,
      languages: [locale ?? 'en'],
    }
    this.holidays = new Holidays(this.options)
  }

  getHolidaysForCountry(year: number, countryCode: string, stateCode?: string, type?: string): IDateHolidaysHoliday[] {
    const typeOptions: Partial<Options> = {
      types: type ? ([type] as HolidayType[]) : undefined,
    }
    // Subdivisions are stored as full ISO 3166-2 ('DE-BY') but date-holidays keys them by the bare
    // suffix ('BY') and returns national holidays, without an error, for an unknown key, so strip the prefix.
    this.holidays.init(countryCode, bareSubdivisionCode(stateCode), { ...typeOptions, ...this.options })
    return this.holidays.getHolidays(year)
  }

  /** The country's region codes, bare ('ON'), as the library keys them. */
  getStates(countryCode: string): string[] {
    return Object.keys(this.holidays.getStates(countryCode) ?? {})
  }

  getCountries() {
    const countries = this.holidays.getCountries()
    return Object.entries(countries).map(([id, name]) => ({ id, name }))
  }
}
